import { useState, useCallback } from 'react'
import { Step, QuizState } from '../types'
import { questions } from '../data/questions'

export function useQuizState() {
  const [state, setState] = useState<QuizState>({
    currentStep: 'intro',
    currentQuestionIndex: 0,
    dogName: '',
    answers: {},
    tags: [],
  })

  const setDogName = useCallback((name: string) => {
    setState((prev) => ({ ...prev, dogName: name }))
  }, [])

  const setAnswer = useCallback(
    (
      questionId: number,
      answer: string | string[],
      tagsToAdd: string[] = [],
    ) => {
      setState((prev) => {
        const newTags = [...prev.tags]
        tagsToAdd.forEach((tag) => {
          if (!newTags.includes(tag)) newTags.push(tag)
        })

        return {
          ...prev,
          answers: { ...prev.answers, [questionId]: answer },
          tags: newTags,
        }
      })
    },
    [],
  )

  const nextQuestion = useCallback(() => {
    setState((prev) => {
      const nextIndex = prev.currentQuestionIndex + 1
      if (nextIndex >= questions.length) {
        return { ...prev, currentStep: 'loading' }
      }
      return { ...prev, currentQuestionIndex: nextIndex }
    })
  }, [])

  const prevQuestion = useCallback(() => {
    setState((prev) => {
      const prevIndex = prev.currentQuestionIndex - 1
      if (prevIndex < 0) return prev
      return { ...prev, currentQuestionIndex: prevIndex }
    })
  }, [])

  const goToStep = useCallback((step: Step) => {
    setState((prev) => ({ ...prev, currentStep: step }))
  }, [])

  const getRiskLevel = useCallback((): 'ALTO' | 'MODERADO' | 'BAJO' => {
    // Always return ALTO to create urgency regardless of answers
    return 'ALTO'
  }, [state.tags])

  return {
    ...state,
    setDogName,
    setAnswer,
    nextQuestion,
    prevQuestion,
    goToStep,
    getRiskLevel,
    totalQuestions: questions.length,
    currentQuestion: questions[state.currentQuestionIndex],
  }
}
